<mat-nav-list class="prestatie-taken">
  <h3 matSubheader
    class="header">
    {{category.getLabel()}}
  </h3>
  <div class="fade-out"></div>
  @for (taak of taken; track getTaakId($index, taak)) {
    <mat-list-item
      [disableRipple]="true" matRipple [matRippleTrigger]="trigger">
      <span matListItemAvatar [ngClass]="taak.getIcoon()"></span>
      <div matListItemTitle>{{taak.getLabel()}}</div>
      @if (taak.getFrequentie()) {
        <div
          matListItemLine
          class="mat-small frequentie">{{taak.getFrequentie() }}
          @if (taakGeschiedenis.getLaatsteUitvoeringsDatum(category.getId(), taak.getId()); as laatsteUitvoeringsDatum) {
            - Laatst op {{laatsteUitvoeringsDatum | date:'d/MM/yyyy'}}
          }
          @if (!taakGeschiedenis.getLaatsteUitvoeringsDatum(category.getId(), taak.getId())) {
            - Nog niet uitgevoerd
          }
        </div>
      }
      <div matListItemLine class="mat-small tips"><span (click)="onOpenTips(taak)">Toon tips {{getTipAantal(taak)}}</span></div>
      <div matListItemMeta #trigger (click)="toggleTaak(taak)">
        <mat-icon color="primary">
          {{prestatie.isUitgevoerd(dienst.getId(), category.getId(), taak.getId()) ? 'check_box' : 'check_box_outline_blank'}}
        </mat-icon>
      </div>
    </mat-list-item>
  }
</mat-nav-list>
